export default __webpack_public_path__ + "static/media/lubaantun1.e2dc6de0.webp";